import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { TaskProvider } from "./components/TaskContext";
import { UserDataProvider } from "./components/UserDataContext";
import { SearchProvider } from "./components/SearchContext";
import Expired from "./components/Expired";
import Login from "./pages/Login";
import NoPermission from "./pages/NoPermission";
import PassResetMail from "./pages/PassResetMail";
import Performers from "./pages/Performers";
import Tasks from "./pages/Tasks";
import PassChange from "./pages/PassChange";
import Menu from "./pages/Menu";
import InternalUsers from "./pages/InternalUsers";
import EditAdmin from "./pages/EditAdmin";
import EditUser from "./pages/EditUser";
import AddTask from "./pages/TaskAdd";
import TaskEdit from "./pages/TaskEdit";
import TasksData from "./pages/TasksData";
import Files from "./pages/Files";
import FileEdit from "./pages/FileEdit";
import TaskMap from "./pages/TaskMap";
import Footer from "./components/Footer";
import Rodo from "./pages/Rodo";
import Categories from "./pages/Categories";
import Projects from "./pages/Projects";
import DocTypes from "./pages/DocTypes";

export const API_URL = "https://ksiegowakatarzyna.pl/api";
export const APP_NAME = "KSIEGOWAKATARZYNA";
export const cookie = "ksiegowakatarzyna";
export const windowWidth = 768;
export const marginBottom = "10px";
export const marginTop = "20px";
export const fontFamily = "Wix Madefor Display";

function App() {
  return (
    <>
      <UserDataProvider>
        <TaskProvider>
          <SearchProvider>
            <main className="page-content">
              <BrowserRouter basename="/">
                <Routes>
                  <Route path="/" element={<Navigate to="/login" />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/nopermission" element={<NoPermission />} />
                  <Route path="/passresetmail" element={<PassResetMail />} />
                  <Route path="/passchange" element={<PassChange />} />
                  <Route path="/performers" element={<Performers />} />
                  <Route path="/addtask" element={<AddTask />} />
                  <Route path="/internalUsers" element={<InternalUsers />} />
                  <Route path="/edituser/:id" element={<EditUser />} />
                  <Route path="/editadmin/:id" element={<EditAdmin />} />
                  <Route path="/taskedit" element={<TaskEdit />} />
                  <Route path="/tasksdata" element={<TasksData />} />
                  <Route path="/files" element={<Files />} />
                  <Route path="/fileedit/:id" element={<FileEdit />} />
                  <Route path="/menu" element={<Menu />} />
                  <Route path="/expired" element={<Expired />} />
                  <Route path="/tasks" element={<Tasks />} />
                  <Route path="/taskmap" element={<TaskMap />} />
                  <Route path="/rodo/:id" element={<Rodo />} />
                  <Route path="/categories" element={<Categories />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/doctypes" element={<DocTypes />} />
                </Routes>
              </BrowserRouter>
            </main>
            <Footer />
          </SearchProvider>
        </TaskProvider>
      </UserDataProvider>
    </>
  );
}

export default App;
